import { Card } from "@volca/ui/components/ui/card";
import { DOORBELL } from "@volca/ui/components/ui/empty-machine";
import { MachineEmptyState } from "@volca/ui/components/ui/machine-empty-state";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { useGetBusinessStats } from "@/business/query";
import { formatPhoneNumber } from "@/core/utils/phone";
import { useGetMyUserWithBusiness } from "@/user/query";
import PostOnboardingItems from "@/waiting-pages/post-onboarding/post-onboarding-items";
import { AdvocateAndReferralCounters } from "./referral-stats/advocate-and-referral-counters";

export const NoReferrals = () => {
  const { data: userWithBusiness } = useGetMyUserWithBusiness();
  const {
    data: businessStats,
    isLoading,
    isError,
  } = useGetBusinessStats(userWithBusiness?.business?.id);

  const business = userWithBusiness?.business;
  if (!business) return null;
  const hasActivity =
    (businessStats?.program_signup_count ?? 0) > 0 ||
    (businessStats?.referral_count ?? 0) > 0;

  return (
    <Stack
      className="w-full flex-1 py-8"
      align="center"
      justify="center"
      gap={8}
    >
      <MachineEmptyState
        art={DOORBELL}
        layout="workspace"
        title={
          business.phone_number
            ? "Ready for your first referral"
            : "No referrals yet"
        }
        description={
          business.phone_number
            ? "Share your referral number with customers to get started."
            : "Your business doesn't have a referral number yet."
        }
        footnote={
          business.phone_number
            ? "New referrals will appear here as customers send them in."
            : "Contact Volca for help setting up your referral number."
        }
      >
        {business.phone_number && (
          <Stack gap={2} className="w-full">
            <Text tone="muted">Let customers know to text REFERRAL to</Text>
            <Text variant="stat" tone="brand">
              {formatPhoneNumber(business.phone_number)}
            </Text>
          </Stack>
        )}
        <PostOnboardingItems collapsible />
      </MachineEmptyState>
      {(hasActivity || isError) && (
        <Card className="w-full max-w-3xl gap-0 py-0">
          <AdvocateAndReferralCounters
            advocates={businessStats?.program_signup_count}
            referrals={businessStats?.referral_count}
            isLoading={isLoading}
            isError={isError}
            className="xl:grid-cols-2"
          />
        </Card>
      )}
    </Stack>
  );
};
